import { GetMonthlyInvoicePeriodDtoMeter, GetOverviewForAddressResponse } from '@eneco/dc-be/client';

export const filterMetersWithYearlyInvoiceFrequency = (
  meters: GetMonthlyInvoicePeriodDtoMeter[] | null | undefined,
  invoiceFrequency: GetOverviewForAddressResponse | null,
  includeTerminatedAccounts : boolean
) => {
  if (!meters || !meters.length) return null;

  return meters.reduce((filteredMeters: GetMonthlyInvoicePeriodDtoMeter[], meter: GetMonthlyInvoicePeriodDtoMeter) => {
    const frequencyActiveProducts = invoiceFrequency?.activeProducts?.find(invoice => invoice.contractId === meter.contractId);
    const frequencyExpiredProducts = invoiceFrequency?.expiredProducts?.find(invoice => invoice.contractId === meter.contractId);

    if (frequencyActiveProducts?.meterReadingMonth !== null && frequencyActiveProducts?.meterReadingMonth !== undefined) {
      filteredMeters.push(meter);
    }
    if (frequencyExpiredProducts?.meterReadingMonth !== null && frequencyExpiredProducts?.meterReadingMonth !== undefined && includeTerminatedAccounts) {
      filteredMeters.push(meter);
    }

    return filteredMeters;
  }, []);
};
